export type CssSize = number | string

export function getCssSizeString(size?: CssSize | null) {
  return typeof size === 'number' || (typeof size === 'string' && size.length && /^\d+(\.\d+)?$/.test(size))
    ? `${size}px`
    : size || ''
}
